import { VirtualPropertyBaseDefinition } from '@core/shared/virtual-properties';
export class CompanyVirtualPropertyBaseDefinition extends VirtualPropertyBaseDefinition {
  getValidAccessGroups() {
    return ['managerOfCompany', 'admin', 'public'];
  }
  // TODO: #86c11upzw - reimplement based on abilities
  getGrantedAccessGroupsForUserAndItem(item, access) {
    const accessGroups = [];
    accessGroups.push('public');
    if (access.isAdmin) accessGroups.push('admin');
    const isManager = access.simpleAbilityCheck('Feature.common-users.Company.Manage');
    const managedCompany = access.getAccessData('managedCompany', null, 'null');
    if (isManager && managedCompany) {
      if (managedCompany.id === item.id) accessGroups.push('managerOfCompany');
    }
    return accessGroups;
  }
}